import React from 'react';

export default function AdminHome() {
  return (
    <div>
      <h2>Admin</h2>
      <p>
        Sale tools will appear in the menu as they are added. Until then, status, dates, and Square syncs
        are managed with the scripts described in the README.
      </p>
    </div>
  );
}
